import Icon from "hardcover-ui/components/Icon";
import chevronDown from "icons/solid/chevron-right.svg";
import Button from "hardcover-ui/components/Button";
import LoadingSpinner from "hardcover-ui/components/LoadingSpinner";
import { ButtonThemeProps } from "hardcover-ui/theme/components/button";
import { ButtonHTMLAttributes, forwardRef, PropsWithChildren } from "react";

type Props = {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  loading?: boolean;
  children: React.ReactNode;
  open?: boolean;
  className?: string;
  ref?: React.RefObject<HTMLButtonElement>;
  size?: ButtonThemeProps["size"];
} & Partial<ButtonHTMLAttributes<HTMLButtonElement>>;

const EditionSelectorButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<Props>
>(
  (
    { className, onClick, loading, size, open = false, children, ...props },
    ref
  ) => {
    return (
      <Button
        className={className}
        variant="tertiary"
        size={size}
        onClick={onClick ? onClick : () => {}}
        data-open={open ? "true" : "false"}
        ref={ref}
        {...props}
      >
        {children}
        {loading ? <LoadingSpinner size="sm" /> : <Icon icon={chevronDown} />}
      </Button>
    );
  }
);

export default EditionSelectorButton;
